export default __webpack_public_path__ + "static/media/logo.59c3ac96.svg";